import objectAssign from "object-assign";
import initialState from "./initialState";
import { formatTime } from "../utils/helpers";

export default function flagshipTime(state = initialState.time, action) {
  let newState = objectAssign({}, state);

  switch (action.type) {
    case "SET_TIMER":
      newState.timeRecorded = action.time;
      newState.timeRecordedFormatted = formatTime(action.time);
      newState.timerRunning = action.running;
      newState.timerVisible =
        action.forceVisible === true ? true : state.timerVisible;
      newState.timerClient = action.client;
      newState.timerTask = action.task;
      return newState;
    case "START_TIMER":
      newState.timerRunning = true;
      newState.timeRecorded = action.start;
      newState.timeRecordedFormatted = formatTime(action.start);
      return newState;
    case "STOP_TIMER":
      newState.timerRunning = false;
      return newState;
    case "INCREMENT_TIMER":
      if (newState.windowBlur !== true || newState.timerVisible === true) {
        newState.timeRecordedFormatted = formatTime(newState.timeRecorded + 1);
        newState.timeRecorded = newState.timeRecorded + 1;
        document.title =
          "[" +
          newState.timeRecordedFormatted +
          "] " +
          document.title.replace(/\[[0-9]{2}:[0-9]{2}:[0-9]{2}\]/i, "");
      }
      return newState;
    case "CLEAR_TIMER":
      newState.timeRecordedFormatted = "00:00:00";
      newState.timeRecorded = 0;
      newState.timerClient = null;
      newState.timerTask = null;
      document.title =
        "[" +
        newState.timeRecordedFormatted +
        "] " +
        document.title.replace(/\[[0-9]{2}:[0-9]{2}:[0-9]{2}\]/i, "");
      return newState;
    case "CLEAR_TIME_ONLY":
      newState.timeRecordedFormatted = "00:00:00";
      newState.timeRecorded = 0;
      document.title =
        "[" +
        newState.timeRecordedFormatted +
        "] " +
        document.title.replace(/\[[0-9]{2}:[0-9]{2}:[0-9]{2}\]/i, "");
      return newState;
    case "TOGGLE_TIMER":
      newState.timerVisible =
        action.force === null ? !newState.timerVisible : action.force;
      return newState;
    case "PICKING_CLIENT":
      newState.pickingClient = action.value;
      return newState;
    case "PICK_CLIENT":
      if (action.client === 0) {
        newState.timerClient = null;
      } else {
        newState.timerClient = action.client;
      }
      return newState;
    case "PICKING_TASK":
      newState.pickingTask = action.value;
      return newState;
    case "PICK_TASK":
      newState.timerTask = action.task;
      return newState;
    case "WINDOW_BLUR":
      newState.windowBlur = action.blurred;
      newState.timeRecordedFormatted = "Updating...";
      if (newState.windowBlur === true && newState.timerVisible === false)
        document.title = document.title.replace(
          /\[[0-9]{2}:[0-9]{2}:[0-9]{2}\]/i,
          ""
        );
      return newState;
    case "STORE_CLIENT":
      newState.timerDefaultClient = action.data;
      return newState;
    case "CLEAR_DEFAULT_CLIENT":
      newState.timerDefaultClient = null;
      return newState;
    case "USE_PREVIOUS_TIMESHEET":
      newState.usingPreviousTimesheet = action.data;
      return newState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timeReducer.js